import { useEffect, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import MultiSelectCheckbox from "../../../../ui/molecules/multiSelectCheckbox";
import TextArea from "../../../../ui/molecules/textArea";
import { normativa } from "../../../../utils";
import { GetAllRequirements, RequirementUpdate, RequirementValidation, resetRequirementErrors, resetRequirements, resetRequirementUpdateRequest, resetRequirementUpdateStatus, resetRequirementValidationStatus, setUpdateNorm, setUpdateRequirement, setUpdateSpec } from "../slice";

interface Props {
    close: () => void
}

export function RequirementPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const requirementState = useAppSelector(state => state.PMRequirement)
    const [selectedNorma, setSelectedNorma] = useState<{ label: string; value: string }[]>([]);

    useEffect(() => {
        const initialNorma = []
        if (requirementState.requirementUpdateRequest.norm) {
            for (const n of requirementState.requirementUpdateRequest.norm) {
                initialNorma.push(n as any)
            }
            setSelectedNorma(initialNorma)
        }

    }, [])

    useEffect(() => {
        if (requirementState.requirementValidationStatus === 'successfully') {
            dispatch(resetRequirementValidationStatus())
            dispatch(resetRequirementErrors())
            dispatch(RequirementUpdate({ body: requirementState.requirementUpdateRequest, id: requirementState.requirementIdToUpdate }))
        }
    }, [requirementState.requirementValidationStatus])

    useEffect(() => {
        if (requirementState.requirementUpdateStatus === 'successfully') {
            dispatch(resetRequirementUpdateStatus())
            dispatch(resetRequirementUpdateRequest())
            dispatch(resetRequirements())
            dispatch(GetAllRequirements())
            props.close()
        }
    }, [requirementState.requirementUpdateStatus])

    return (
        <Fragment>
            <div className="bg-white p-6 flex flex-col gap-6">

                <MadfarmInput
                    error={requirementState.requirementErrors.requirement}
                    supportingText={requirementState.requirementErrors.requirement ? 'Nome mancante!' : undefined}
                    label={'Titolo del requisito'}
                    placeholder="Specificare il nome del requisito"
                    value={requirementState.requirementUpdateRequest.requirement}
                    defaultValue={requirementState.requirementUpdateRequest.requirement}
                    onChangeText={(text) => { dispatch(setUpdateRequirement(text)) }}
                />
                <MultiSelectCheckbox
                    label="Norma di riferimento"
                    error={requirementState.requirementErrors.norm}
                    errorLabel="Non è presente nessuna normativa!"
                    onChange={(e) => {
                        setSelectedNorma(e.value)
                        dispatch(setUpdateNorm(e.value))
                    }}
                    value={selectedNorma}
                    option={normativa}
                    placeholder="Norma di riferimento"
                    selectAllLabel="Tutte"
                />
                <TextArea
                    label="Specifiche del requisito"
                    placeholder="Descrivi le specifiche del requisito"
                    value={requirementState.requirementUpdateRequest.spec}
                    defaultValue={requirementState.requirementUpdateRequest.spec}
                    error={requirementState.requirementErrors.spec}
                    supportingText={requirementState.requirementErrors.spec ? 'Specifiche mancanti!' : undefined}
                    onChangeText={(text) => dispatch(setUpdateSpec(text))} />
            </div>
            <div className="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4 bg-neutral-50">
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    onClick={() => {
                        dispatch(resetRequirementUpdateRequest())
                        dispatch(resetRequirementErrors())
                        props.close();
                    }}
                />
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Salva"
                    color="orange"
                    onClick={() => {
                        dispatch(RequirementValidation(requirementState.requirementUpdateRequest))
                    }}
                />
            </div>
        </Fragment>
    )
}